import { ReactNode } from 'react';
import {
  Baccarat,
  Blackjack,
  DropWins,
  GameLobby,
  Live,
  Megaways,
  New,
  Poker,
  Roulette,
  Slots,
  TopGames,
  Instant,
  Jackpots,
  JackpotsGold,
  JackpotsSilver,
  JackpotsBronze,
  PragmaticPlayIcon,
  EventIcon
} from 'src/components/svg/CategorySwitcher';
import sidebarDrop from 'src/assets/sidebar-icons/sidebarDrop.png';
import sidebarJackpots from 'src/assets/sidebar-icons/jackpots.png';
import sidebarTop from 'src/assets/sidebar-icons/sidebarTop.png';
import sidebarBonus from 'src/assets/sidebar-icons/sidebarBonus.png';
import sidebarLive from 'src/assets/sidebar-icons/sidebarLive.png';
import sidebarSlots from 'src/assets/sidebar-icons/sidebarSlots.png';
import sidebarAviator from 'src/assets/sidebar-icons/sidebarAviator.png';
import sidebarNew from 'src/assets/sidebar-icons/sidebarNew.png';
import sidebarMegaWays from 'src/assets/sidebar-icons/sidebarMegaWays.png';
import sidebarInstant from 'src/assets/sidebar-icons/instant.webp';
import iconFavoritesGames from 'src/assets/sidebar-icons/heart.webp';
import { HeartIcon } from 'src/components/svg/HeartIcon';
import { EVENT_NAME, EVENT_TITLE } from 'src/config/helpers';

export type GameCategoryParams = {
  param: string; // название категории для бэкенда
  title: string; // локализованное название категории
  path: GameCategoryName | typeof EVENT_NAME;
  icon: JSX.Element; // иконка категории игры
  image: JSX.Element; // картинка категории игры
};

export type GameCategoryName =
  | 'new'
  | 'top'
  | 'favorites'
  | 'jackpots'
  | 'live'
  | 'games-lobby'
  | 'slots'
  | 'megaways'
  | 'fruits'
  | 'bonusbuy'
  | 'books'
  | 'dropswin'
  | 'blackjack'
  | 'baccarat'
  | 'poker'
  | 'aviator'
  | 'roulette'
  | 'bonus-games'
  | 'instant'
  | 'jackpot-gold'
  | 'jackpot-silver'
  | 'jackpot-bronze'
  | 'pragmatic-play'
  | typeof EVENT_NAME;

export const GAME_CATEGORIES: Record<GameCategoryName, GameCategoryParams> = {
  'games-lobby': {
    param: 'all',
    title: 'categoriesItem.gamesLobby',
    path: 'games-lobby',
    icon: <GameLobby className="color-hover" />,
    image: <></>
  },
  new: {
    param: 'new',
    title: 'gameCategories.newGames',
    path: 'new',
    icon: <New className="color-hover" />,
    image: <img src={sidebarNew} alt="dice" style={{ maxWidth: '20px' }} />
  },
  top: {
    param: 'top',
    title: 'gameCategories.top',
    path: 'top',
    icon: <TopGames className="color-hover" />,
    image: <img src={sidebarTop} alt="diamond" style={{ maxWidth: '20px' }} />
  },
  live: {
    param: 'live',
    title: 'gameCategories.live',
    path: 'live',
    icon: <Live className="color-hover" />,
    image: <img src={sidebarLive} alt="liveCard" style={{ maxWidth: '20px' }} />
  },
  slots: {
    param: 'slots',
    title: 'gameCategories.slots',
    path: 'slots',
    icon: <Slots className="color-hover" />,
    image: <img src={sidebarSlots} alt="cherry" style={{ maxWidth: '20px' }} />
  },
  megaways: {
    param: 'megaways',
    title: 'categoriesItem.megaways',
    path: 'megaways',
    icon: <Megaways className="color-hover" />,
    image: <img src={sidebarMegaWays} alt="slot" style={{ maxWidth: '20px' }} />
  },
  fruits: {
    param: 'fruit',
    title: 'categoriesItem.fruits',
    path: 'fruits',
    icon: <></>,
    image: <></>
  },
  bonusbuy: {
    param: 'bonusbuy',
    title: 'categoriesItem.bonus',
    path: 'bonusbuy',
    icon: <></>,
    image: <></>
  },
  books: {
    param: 'book',
    title: 'categoriesItem.bookSlots',
    path: 'books',
    icon: <></>,
    image: <></>
  },
  dropswin: {
    param: 'dropwinscat',
    title: 'categoriesItem.dropWins',
    path: 'dropswin',
    icon: <DropWins className="color-hover" />,
    image: <img src={sidebarDrop} alt="dropswin" style={{ maxWidth: '20px' }} />
  },
  blackjack: {
    param: 'blackjack',
    title: 'categoriesItem.blackjack',
    path: 'blackjack',
    icon: <Blackjack className="color-hover" />,
    image: <></>
  },
  baccarat: {
    param: 'baccara',
    title: 'categoriesItem.baccarat',
    path: 'baccarat',
    icon: <Baccarat className="color-hover" />,
    image: <></>
  },
  poker: {
    param: 'poker',
    title: 'categoriesItem.poker',
    path: 'poker',
    icon: <Poker className="color-hover-stroke" />,
    image: <></>
  },
  roulette: {
    param: 'roulette',
    title: 'categoriesItem.roulette',
    path: 'roulette',
    icon: <Roulette className="color-hover" />,
    image: <></>
  },
  aviator: {
    param: 'aviator',
    title: 'aviator',
    path: 'aviator',
    icon: <></>,
    image: <img src={sidebarAviator} alt="aviator" style={{ maxWidth: '20px' }} />
  },
  'bonus-games': {
    param: 'my-bonus-games',
    title: 'gameCategories.bonusGames',
    path: 'bonus-games',
    icon: <></>,
    image: <img src={sidebarBonus} alt="lightning" style={{ maxWidth: '20px' }} />
  },
  jackpots: {
    param: 'jackpots',
    title: 'gameCategories.jackpots',
    path: 'jackpots',
    icon: <Jackpots className="color-hover" />,
    image: <img src={sidebarJackpots} alt="jackpots" style={{ maxWidth: '20px' }} />
  },
  instant: {
    param: 'instant',
    title: 'instant',
    path: 'instant',
    icon: <Instant className="color-hover" />,
    image: <img src={sidebarInstant} alt="instant" style={{ maxWidth: '20px' }} />
  },
  favorites: {
    param: 'favorites',
    title: 'gameCategories.favorites',
    path: 'favorites',
    icon: <HeartIcon className="heart-icon w-full" />,
    image: <img src={iconFavoritesGames} alt="easter" />
  },
  'jackpot-gold': {
    param: 'jackpot-gold',
    title: 'jackpotsPage.gold',
    path: 'jackpot-gold',
    icon: <JackpotsGold className="color-hover-euro" />,
    image: <></>
  },
  'jackpot-silver': {
    param: 'jackpot-silver',
    title: 'jackpotsPage.silver',
    path: 'jackpot-silver',
    icon: <JackpotsSilver className="color-hover-euro" />,
    image: <></>
  },
  'jackpot-bronze': {
    param: 'jackpot-bronze',
    title: 'jackpotsPage.bronze',
    path: 'jackpot-bronze',
    icon: <JackpotsBronze className="color-hover" />,
    image: <></>
  },
  'pragmatic-play': {
    param: 'pragmatic_play',
    title: 'Pragmatic Play',
    path: 'pragmatic-play',
    icon: <PragmaticPlayIcon className="color-hover" />,
    image: <PragmaticPlayIcon className="color-hover w-[18px] h-[18px]" />
  },
  [EVENT_NAME]: {
    param: EVENT_NAME,
    title: EVENT_TITLE,
    path: EVENT_NAME,
    icon: <EventIcon />,
    image: <EventIcon className="w-5" />
  }
};

export type GameCategoryData = {
  name: string;
  path: `/games/${GameCategoryName}` | '/games';
  image: ReactNode;
};

export const gameCategoriesMainList = [
  GAME_CATEGORIES['games-lobby'],
  GAME_CATEGORIES[EVENT_NAME],
  GAME_CATEGORIES.favorites,
  GAME_CATEGORIES.live,
  GAME_CATEGORIES.slots,
  GAME_CATEGORIES.jackpots,
  GAME_CATEGORIES.top,
  GAME_CATEGORIES['pragmatic-play'],
  GAME_CATEGORIES.instant,
  GAME_CATEGORIES.dropswin,
  GAME_CATEGORIES.new,
  GAME_CATEGORIES.megaways
];

export const gamesCategoriesSidebar = [
  GAME_CATEGORIES[EVENT_NAME],
  GAME_CATEGORIES.favorites,
  GAME_CATEGORIES.slots,
  GAME_CATEGORIES.top,
  GAME_CATEGORIES.jackpots,
  GAME_CATEGORIES.instant,
  GAME_CATEGORIES.new,
  GAME_CATEGORIES.megaways,
  GAME_CATEGORIES['pragmatic-play'],
  GAME_CATEGORIES.live,
  GAME_CATEGORIES['bonus-games'],
  GAME_CATEGORIES.aviator,
  GAME_CATEGORIES.dropswin
];

export const gameCategoriesLiveGroup = (() => {
  const liveGames = [
    GAME_CATEGORIES.slots,
    GAME_CATEGORIES.live,
    GAME_CATEGORIES.blackjack,
    GAME_CATEGORIES.baccarat,
    GAME_CATEGORIES.poker,
    GAME_CATEGORIES.roulette
  ];

  // если нужно добавить или удалить новую категорию
  // if (!isBjLeagueVisible()) {
  //   return liveGames.filter((category) => category.path !== 'blackjack-league');
  // }

  return liveGames;
})();

export const gameCategoriesMainJackpotList = [
  GAME_CATEGORIES.slots,
  GAME_CATEGORIES.jackpots,
  GAME_CATEGORIES['jackpot-bronze'],
  GAME_CATEGORIES['jackpot-silver'],
  GAME_CATEGORIES['jackpot-gold']
];
export const LIVE_SUBCATEGORIES: GameCategoryName[] = [
  'roulette',
  'poker',
  'baccarat',
  'blackjack',
  'live'
];
